/**
 * Created by mark on 17/12/2017.
 */
import Constants from '../constants.js';
import UserService from '../services/user-service.js';

class UserStore {

    constructor(){
        this.usersAccounts =  [];
        this.account = {account_uid:null};
        this.personal = {}
        this.archive1 = [];
        this.archive2 = [];
        this.favs = [];
    }

    setAccount(accountUID){
        this.account = accountUID;
        UserService.isAdminRegistered();
    }

    getPersonal()
    {
        return this.personal || {};
    }

    import(action, response) {
        switch (action.type) {
          case Constants.GET_PERSONAL_INFROMATION:
              this.personal = response
              break;
          case Constants.IS_ACCOUNT_REGISTERED:
              this.account.is_registered = response.isRegistered
              break;
          default:
              break;
        }
    }

    once(action, response) {
        if (this.actions[action] == undefined) {
            this.actions[action] = [];
        }
        this.actions[action].push(response);
    }

    trigger(action) {
        if (this.actions[action] != undefined) {
            for (var  i =0; i <this.actions[action].length; i++ ) {
                this.actions[action][i]();
            }
        }
    }
}

let exportClass = new UserStore();
export default exportClass;